<div class="map-wrapper">

  <div class="map-container" [id]="containerName"></div>

  <div class="localityBox map-overlay-container">
    <app-b2b-popover-v1
      [isToggleHeaderClick]="false"
      [isOpenHeaderClick]="true"
      [allowContentDrop]="false" [allowBackdropClose]="true" [width]="isMobile ? '92%': '40%'" [top]="'44px'"
      [left]="'6px'"
      [background]="'transparent'" [border]="'none'"
      #mapLocalityPopover
    >
      <div header>
        <div class="loc-re">
          <div class="input-box locality list-location"
               id="map-locality-popover">
            <div class="inp-label">
              <input [formControl]="searchControl"
                     class="input-field bold-value"
                     [placeholder]="'Enter Landmark/Locality'"
              >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div body class="search-destination">
        @if (displayOptions?.length > 0) {
          <ion-list [lines]="'none'" class="no-padding-top no-padding-bottom">
            <div class="pad-mob">
              @for (option of displayOptions;
                track option;
                let i = $index;
                let l = $last) {
                <div (click)="onItemClickFunc(option, i); mapLocalityPopover?.close()" class="locList">
                  <span class="title-case">{{ option?.title | titlecase }}</span>
                </div>
              }
            </div>
          </ion-list>
        } @else {
          <!-- TODO please enter locality, place name, landmark -->
          <div class="locList error">Please enter a locality, landmark or place name</div>
        }
      </div>
    </app-b2b-popover-v1>
  </div>

</div>

